import React, { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { Link } from 'react-router-dom'
import { Container, Typography, Box } from '@mui/material'
import { withStyles } from '@mui/styles'

import { ThemeButton } from '../../../ui'
import { GasAppDashboard } from '../../../features/gas-applications'
import { useGasAppData } from '../../../features/gas-applications'
import { gasApplicationsdStyles } from './gas-applications.styles'

export const GasApplicationsPage = withStyles(gasApplicationsdStyles)(({ classes }) => {
  const { formatMessage } = useIntl()
  const { applications, updateGasApps } = useGasAppData()

  useEffect(() => updateGasApps(), []) // eslint-disable-line

  return (
    <div className={classes.root}>
      <Container className={classes.container} maxWidth="md">
        {applications?.length !== 0 ? (
          <>
            <div className={classes.titleWrapper}>
              <Typography variant="h4" color="primary" component="p">
                {formatMessage({ id: 'pages.gasApplications.title' })}
              </Typography>
            </div>
            <div className={classes.contentWrapper}>
              <GasAppDashboard />
            </div>
          </>
        ) : (
          <Box textAlign="center">
            <Typography variant="h5" component="p" sx={{ mb: 2 }}>
              {formatMessage({ id: 'pages.gasApplications.notFound' })}
            </Typography>
            <Link to="/home" replace>
              <ThemeButton
                type="submit"
                color="primary"
                labelM="large"
                sx={{ mx: 6, fontFamily: 'FSEmeric-Medium' }}
              >
                {formatMessage({ id: 'global.return' })}
              </ThemeButton>
            </Link>
          </Box>
        )}
      </Container>
    </div>
  )
})
